import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const PricePackageForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.pricePackage_text_price_order,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'pricePackageOrder',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 999999 }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.pricePackage_text_hsn_code,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'hsnCode',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: false,
    },
    {
      label: strings.pricePackage_text_content,
      value: '',
      autoFocus: true,
      type: 'textEditor',
      placeholder: '',
      field: 'description',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: strings.pricePackage_text_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
  ];
};
